import { createApp } from 'vue';
import DocumentSearch from './DocumentSearch.vue';
import { initFormKitSchema } from 'shared/utils/initFormKitSchema';
import store from 'shared/store';

async function mountDocumentSearch() {
	const documentSearchComponent = document.getElementById('document-search');

	if (!documentSearchComponent) {
		console.warn('[documentSearch] Container not found');
		return;
	}

	const app = createApp({
		name: 'DocumentSearchApp',
	});
	app.component('document-search', DocumentSearch);
	await initFormKitSchema(app);
	app.use(store);
	app.mount(documentSearchComponent);
}

mountDocumentSearch().catch((error) => {
	console.error('Error mounting DocumentSearch:', error);
});
